import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS } from "../i18n";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage ?? "pt";
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(max-width: 640px), (display-mode: standalone)");
    const update = () => setCompact(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return (
    <label className="lang-switcher">
      <span className="sr-only">{t("footer.language")}</span>
      <select
        value={current}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        aria-label={t("footer.language")}
      >
        {SUPPORTED_LANGS.map((lng) => (
          <option key={lng.code} value={lng.code}>
            {compact ? lng.code.toUpperCase() : lng.label}
          </option>
        ))}
      </select>
    </label>
  );
}
